import opentelemetry, { diag } from '@opentelemetry/api'
import {
  DEFAULT_MXL_API_KEY,
  DEFAULT_MXL_NODE_BETA_MODE,
  DEFAULT_SERVICE_NAME,
} from './constants'
import { type MXLPinoOptions, getMixinFunction } from './otel-logger/pino'
import MXLWinston, { type MXLWinstonOptions } from './otel-logger/winston'

type WinstonTransportOptions = Omit<
  MXLWinstonOptions,
  'apiKey' | 'getCustomMeta' | 'resourceAttributes'
>

type PinoTransportOptions = Omit<
  MXLPinoOptions,
  'apiKey' | 'getCustomMeta' | 'resourceAttributes'
>

const getCustomMeta = () => {
  //@ts-ignore
  const contextManager = opentelemetry.context?._getContextManager()
  if (typeof contextManager?.getMutableContext === 'function') {
    const mutableContext = contextManager.getMutableContext()
    if (mutableContext?.traceAttributes != null) {
      return Object.fromEntries(mutableContext.traceAttributes)
    }
  }

  return {}
}

export const getWinstonTransport = (
  maxLevel = 'info',
  options: WinstonTransportOptions = {}
) => {
  diag.debug('Initializing winston transport')
  const apiKey = DEFAULT_MXL_API_KEY()
  return new MXLWinston({
    ...(apiKey && {
      headers: {
        Authorization: apiKey,
      },
    }),
    maxLevel,
    service: DEFAULT_SERVICE_NAME(),
    getCustomMeta: DEFAULT_MXL_NODE_BETA_MODE() ? getCustomMeta : () => ({}),
    ...options,
  })
}

export const getPinoMixinFunction = getMixinFunction
export const getPinoTransport = (
  maxLevel = 'info',
  options: PinoTransportOptions = {}
) => {
  const apiKey = DEFAULT_MXL_API_KEY()

  return {
    target: '@safaricom-mxl/node/build/src/otel-logger/pino',
    options: {
      ...(apiKey && {
        headers: {
          Authorization: apiKey,
        },
      }),
      service: DEFAULT_SERVICE_NAME(),
      // getCustomMeta, // FIXME: DOMException [DataCloneError]
      // this seems to be because pino does not allow functions in transport options
      // Ref: https://github.com/pinojs/pino/issues/1511
      ...options,
    },
    level: maxLevel,
  }
}
